import { URI, VERSION, MODELNAME, packageUrl, packageNoSubmoduleUrl } from '@/model/config';

const METHOD = {
    getCurrentUser: 'getCurrentUser'
};

const COMMON = {
    baseurl: URI,
    model: MODELNAME,
    version: VERSION,
    method: METHOD,
    url: {
        getCurrentUser: packageNoSubmoduleUrl(METHOD.getCurrentUser, 'account')
    }
};

export default COMMON;
